const getModule = () => import('./editor.module')

const lazyLoadModule = [
  '$q',
  '$ocLazyLoad',
  ($q, $ocLazyLoad) => {
    const deferred = $q.defer()
    getModule().then(({ editorModule }) => {
      $ocLazyLoad.load({
        name: editorModule.name
      })
      deferred.resolve(editorModule)
    })
    return deferred.promise
  }
]

/* @ngInject */
function routes ($stateProvider, $urlRouterProvider) {
  $stateProvider
    .state('customizeTemplate', {
      url: '/arts/templates/:templateId/customize?customWidth&customHeight&resizeArt',
      views: {
        '': {
          templateUrl: '/editor/pages/customize/customize.html?$$REVISION$$',
          controller: 'CustomizeController'
        },
        'componentsTexts@customizeTemplate': {
          templateUrl: '/editor/pages/customize/texts/texts.html?$$REVISION$$',
          controller: 'TextsController'
        },
        'componentsPlaceholder@customizeTemplate': {
          templateUrl: '/editor/pages/customize/placeholders/placeholders.html?$$REVISION$$',
          controller: 'PlaceholdersController'
        },
        'componentsPhotoframes@customizeTemplate': {
          templateUrl: '/editor/pages/customize/photoframes/photoframes.html?$$REVISION$$',
          controller: 'PhotoframesController'
        },
        'componentsElements@customizeTemplate': {
          templateUrl: '/editor/pages/customize/elements/elements.html?$$REVISION$$',
          controller: 'ElementsController'
        },
        'componentsProducts@customizeTemplate': {
          templateUrl: '/editor/pages/customize/products/products.html?$$REVISION$$',
          controller: 'ProductsController'
        },
        'componentsBackgrounds@customizeTemplate': {
          templateUrl: '/editor/pages/customize/backgrounds/backgrounds.html?$$REVISION$$',
          controller: 'BackgroundsController'
        },
        'componentsImages@customizeTemplate': {
          templateUrl: '/editor/pages/customize/images/images.html?$$REVISION$$',
          controller: 'ImagesController'
        },
        'componentsImport@customizeTemplate': {
          templateUrl: '/editor/pages/customize/import/import.html?$$REVISION$$',
          controller: 'ImportController'
        },
        'pagesGrid@customizeTemplate': {
          templateUrl: '/editor/pages/customize/pages-grid/pages-grid.html?$$REVISION$$',
          controller: 'PagesGridController'
        },
        customsize: {
          templateUrl: '/editor/pages/customize/custom-size/custom-size.html?$$REVISION$$'
        }
      },
      params: {
        from: null,
        fromParams: null,
        userView: false,
        resizeArt: null
      },
      reloadOnSearch: false,
      resolve: {
        lazyLoadModule
      }
    })
    .state('customizeArt', {
      url: '/arts/:idArt/customize?resizeArt',
      views: {
        '': {
          templateUrl: '/editor/pages/customize/customize.html?$$REVISION$$',
          controller: 'CustomizeController'
        },
        'componentsTexts@customizeArt': {
          templateUrl: '/editor/pages/customize/texts/texts.html?$$REVISION$$',
          controller: 'TextsController'
        },
        'componentsPlaceholder@customizeArt': {
          templateUrl: '/editor/pages/customize/placeholders/placeholders.html?$$REVISION$$',
          controller: 'PlaceholdersController'
        },
        'componentsPhotoframes@customizeArt': {
          templateUrl: '/editor/pages/customize/photoframes/photoframes.html?$$REVISION$$',
          controller: 'PhotoframesController'
        },
        'componentsElements@customizeArt': {
          templateUrl: '/editor/pages/customize/elements/elements.html?$$REVISION$$',
          controller: 'ElementsController'
        },
        'componentsProducts@customizeArt': {
          templateUrl: '/editor/pages/customize/products/products.html?$$REVISION$$',
          controller: 'ProductsController'
        },
        'componentsBackgrounds@customizeArt': {
          templateUrl: '/editor/pages/customize/backgrounds/backgrounds.html?$$REVISION$$',
          controller: 'BackgroundsController'
        },
        'componentsImages@customizeArt': {
          templateUrl: '/editor/pages/customize/images/images.html?$$REVISION$$',
          controller: 'ImagesController'
        },
        'componentsImport@customizeArt': {
          templateUrl: '/editor/pages/customize/import/import.html?$$REVISION$$',
          controller: 'ImportController'
        },
        'pagesGrid@customizeArt': {
          templateUrl: '/editor/pages/customize/pages-grid/pages-grid.html?$$REVISION$$',
          controller: 'PagesGridController'
        },
        customsize: {
          templateUrl: '/editor/pages/customize/custom-size/custom-size.html?$$REVISION$$'
        }
      },
      params: {
        hideConvertTemplateButton: false,
        hideShareButton: false,
        showApprovalButtons: false,
        from: null,
        fromParams: null,
        userView: false,
        resizeArt: null
      },
      reloadOnSearch: false,
      resolve: {
        lazyLoadModule
      }
    })
    .state('startFromBlank', {
      url: '/arts/templates/products/:id/customize?customWidth&customHeight&resizeArt',
      views: {
        '': {
          templateUrl: '/editor/pages/customize/customize.html?$$REVISION$$',
          controller: 'CustomizeController'
        },
        'componentsTexts@startFromBlank': {
          templateUrl: '/editor/pages/customize/texts/texts.html?$$REVISION$$',
          controller: 'TextsController'
        },
        'componentsPlaceholder@startFromBlank': {
          templateUrl: '/editor/pages/customize/placeholders/placeholders.html?$$REVISION$$',
          controller: 'PlaceholdersController'
        },
        'componentsPhotoframes@startFromBlank': {
          templateUrl: '/editor/pages/customize/photoframes/photoframes.html?$$REVISION$$',
          controller: 'PhotoframesController'
        },
        'componentsElements@startFromBlank': {
          templateUrl: '/editor/pages/customize/elements/elements.html?$$REVISION$$',
          controller: 'ElementsController'
        },
        'componentsProducts@startFromBlank': {
          templateUrl: '/editor/pages/customize/products/products.html?$$REVISION$$',
          controller: 'ProductsController'
        },
        'componentsBackgrounds@startFromBlank': {
          templateUrl: '/editor/pages/customize/backgrounds/backgrounds.html?$$REVISION$$',
          controller: 'BackgroundsController'
        },
        'componentsImages@startFromBlank': {
          templateUrl: '/editor/pages/customize/images/images.html?$$REVISION$$',
          controller: 'ImagesController'
        },
        'componentsImport@startFromBlank': {
          templateUrl: '/editor/pages/customize/import/import.html?$$REVISION$$',
          controller: 'ImportController'
        },
        'pagesGrid@startFromBlank': {
          templateUrl: '/editor/pages/customize/pages-grid/pages-grid.html?$$REVISION$$',
          controller: 'PagesGridController'
        },
        customsize: {
          templateUrl: '/editor/pages/customize/custom-size/custom-size.html?$$REVISION$$'
        }
      },
      params: {
        hideConvertTemplateButton: false,
        hideShareButton: false,
        showApprovalButtons: false,
        customWidth: null,
        customHeight: null,
        from: null,
        artCollectionId: null,
        fromParams: null,
        importLayers: [],
        userView: false,
        name: '',
        resizeArt: null,
        campaign: null,
        location: null
      },
      reloadOnSearch: false,
      resolve: {
        lazyLoadModule
      }
    })
}

export const editorRoutes = routes
